// extracted by mini-css-extract-plugin
export var loadingSpinner = "_s-0";
export var spinnerContainer = "_s-1";